// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetIntegrationJdQuery,
    BaseResponseListIntegrationConfigFoundResponse,
    PostIntegrationJdBody,
    BaseResponseIntegrationConfigFoundResponse,
} from '../../types';

/**
 * findAll
 *
 * @export
 * @tags integration-config-controller
 * @link [GET] /integration/jd
 */
export function getIntegrationJd(): Promise<BaseResponseListIntegrationConfigFoundResponse>;
export function getIntegrationJd(
    options: ApiOptions<never, GetIntegrationJdQuery>
): Promise<BaseResponseListIntegrationConfigFoundResponse>;
export function getIntegrationJd(
    options?: ApiOptions<never, GetIntegrationJdQuery>
): Promise<BaseResponseListIntegrationConfigFoundResponse> {
    return request<never, never, GetIntegrationJdQuery>('/integration/jd', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getIntegrationJd',
    });
}

/**
 * save
 *
 * @export
 * @tags integration-config-controller
 * @link [POST] /integration/jd
 */
export function postIntegrationJd(
    data: PostIntegrationJdBody
): Promise<BaseResponseIntegrationConfigFoundResponse>;
export function postIntegrationJd(
    data: PostIntegrationJdBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseIntegrationConfigFoundResponse>;
export function postIntegrationJd(
    data: PostIntegrationJdBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseIntegrationConfigFoundResponse> {
    return request<PostIntegrationJdBody, never, never>('/integration/jd', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postIntegrationJd',
    });
}

export const meta = [
    { tags: ['integration-config-controller'], path: '/integration/jd', method: 'get' },
    { tags: ['integration-config-controller'], path: '/integration/jd', method: 'post' },
];
